import { useState, useEffect, useCallback, useRef } from "react";
import Papa from 'papaparse';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from "react-helmet-async";
import {
  Link as RouterLink,
  useNavigate,
  useParams,
  useLocation,
  NavLink,
} from "react-router-dom";
import { useForm } from "react-hook-form";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";
import $ from "jquery";
// @mui
import { styled } from "@mui/material/styles";
import { Button, Typography, Container, Box, Modal } from "@mui/material";
import { format } from "date-fns";
import * as userActions from "../../actions/userActions";
import config from "../../config";
import { encryptData } from "../../utils/cryptoUtils";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "../common.scss";
import * as leadActions from "../../actions/leadActions";
 
import AccessDenied from "../common/AccessDenied";
 
 // ----------------------------------------------------------------------

const StyledContent = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  padding: theme.spacing(12, 0),
}));

const styles = {
  overlay: {
    position: 'fixed',
    top: 0, left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modal: {
    position: 'relative',
    width: '80%',
    height: '80%',
    backgroundColor: '#fff',
    borderRadius: '10px',
    overflow: 'hidden',
  },
  iframe: {
    width: '100%',
    height: '100%',
  },
  closeButton: {
    position: 'absolute',
    top: 10,
    right: 15,
    fontSize: '24px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
  },
};

// ----------------------------------------------------------------------
const RCfromChassis = (props) => {
  const { id, actionName } = useParams();
  const location = useLocation();
  const {
    actions} = props;
   
  const [leadId, setLeadId] = useState(""); 
   
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();
  const navigate = useNavigate();

  const [showLeadCommunicationDetails, setShowLeadCommunicationDetails] =
    useState(false);
  const [allSourceData, setAllSource] = useState([]);
  const [allMasterProfiles, setAllMasterProfiles] = useState([]);
  const [allInteractionTypeData, setAllInteractionTypeData] = useState([]);
  const [allLeadStatusData, setAllLeadStatusData] = useState([]);
  const [allInteractions, setAllInteractions] = useState([]);
  const [allLeadCheckLists, setAllLeadCheckLists] = useState([]);
  const [pageHeading, setPageHeading] = useState("");
  const [questions, setQuestions] = useState([]);

  const [addModulePermissionStatus, setAddModulePermissionStatus] =
    useState(false);
  const [editModulePermissionStatus, setEditModulePermissionStatus] =
    useState(false);
  const [userHasPermission, setUserHasPermission] = useState(true);
  const [permissions, setPermissions] = useState([]);

  const [panDetailsInfoName, setPanDetailsInfoName] = useState("");
  const [chassisNumberDetailsInfoName, setChassisNumberDetailsInfoName] = useState("");
  const [panDetailsInfoDoB, setPanDetailsInfoDoB] = useState("");
  const [panDetailsInfoGender, setPanDetailsInfoGender] = useState("");
  const [panDetailsInfoAddress, setPanDetailsInfoAddress] = useState("");
  const [leadPanDetails, setLeadPanDetails] = useState("");
  const [showTicketListDetails, setShowTicketListDetails] = useState(false);
  const [allTicketData, setAllTicketData] = useState([]);

  const [showListDetails, setShowListDetails] = useState(false);
  const [allGroupData, setAllGroupData] = useState([]);
  const [getAllUsersListData, setAllUsersListData] = useState([]);

  const [allLeadGstByLeadData, setAllLeadGstByLeadData] = useState([]);
  const [allLeadItrByLeadData, setAllLeadItrByLeadData] = useState([]);
  const [allLeadBankStatementByLeadData, setAllLeadBankStatementByLeadData] =
    useState([]);
    const [allLeadBankStatementCount, setAllLeadBankStatementCount] =
    useState(0);
  const [userRoleType, setUserRoleType] = useState("User");
  const [loggeInUserID, setLoggeInUserID] = useState("");
  const [isCrifUser, setIsCrifUser] = useState(true);
  const [isExternalUser, setIsExternalUser] = useState(false);

  const [allStates, setAllStates] = useState([]);
  const [allAddressTypes, setAllAddressTypes] = useState([]);
  const [showNote, setShowNote] = useState("");
  const [showNoteNoteByCredit, setShowNoteNoteByCredit] = useState("");
  const [showHistory, setShowHistory] = useState(false);
  const [allPrefillTemplateNameData, setAllPrefillTemplateNameData] = useState(
    []
  );
  const [allCampaigns, setAllCampaigns] = useState([]);
  const [showActionLeadInfo, setShowActionLeadInfo] = useState(false);

  const [selectedCampaign, setSelectedCampaign] = useState("");
  const [selectedAssignedGroup, setSelectedAssignedGroup] = useState("");
  const [assignedUser, setAssignedUser] = useState("");

  const [isSentToCredit, setIsSentToCredit] = useState(true);

  const [allLeadActivity, setAllLeadActivity] = useState([]);
  const [preloaderStatus, setPreloaderStatus] = useState(false);
  const [preloaderStatusChassisNumber, setPreloaderStatusChassisNumber] = useState(false);
  const [preloaderBulkChassisNumber, setPreloaderBulkChassisNumber] = useState(false);
  const [actionType, setActionType] = useState("");
  const [activeTabName, setActiveTabName] = useState("basic");
  const [activeTab, setActiveTab] = useState("communication");

  const [allLeadCheckListScore, setAllLeadCheckListScore] = useState([]);
  const [allLeadCheckListDynamicScore, setAllLeadCheckListDynamicScore] =
    useState([]);

  const [creditAllLeadCheckLists, setCreditAllLeadCheckLists] = useState([]);
  const [scoreCard, setScoreCard] = useState("");
  const [allShipment, setAllShipment] = useState([]);
  const [leadStatusFlag, setLeadStatusFlag] = useState(false);
  const [outputBefiscHtml, setOutputBefiscHtml] = useState("");
  const [isExternalUserContent, setIsExternalUserContent] = useState("");
  const [mobileReadOnly, setMobileReadOnly] = useState(false);

  const [allOem, setAllOem] = useState([]);
  const [allOemUsage, setAllOemUsage] = useState([]);

  const [allFiSaveHistory, setAllFiSaveHistory] = useState([]);

  // lead Type start
  const [getAllChildsData1, setAllChildsData1] = useState([]);
  const [selectedOutcome, setSelectedOutcome] = useState("");

  const [preloaderAadharStatus, setPreloaderAadharStatus] = useState(false);
  const [preloaderAadharOTPVerifyStatus, setPreloaderAadharOTPVerifyStatus] =
    useState(false);
  const [aadharVerifiedByName, setAadharVerifiedByName] = useState("");
  const [aadharVerifiedDate, setAadharVerifiedDate] = useState("");
  const [leadAadharDetails, setLeadAadharDetails] = useState("");
  const [skipAadharNumberToSave, setSkipAadharNumberToSave] = useState(true);
  const [aadharVerifiedStatus, setAadharVerifiedStatus] = useState(false);
  const [aadharOTPSentStatus, setAadharOTPSentStatus] = useState("0");
  const [aadharRefid, setAadharRefid] = useState("0");
  const [aadharValidationID, setAadharValidationID] = useState("");
  const [referenceId, setReferenceId] = useState("");
  const [isNameStyled, setIsNameStyled] = useState(false);
  const [isDobStyled, setIsDobStyled] = useState(false);
  const [isAddressStyled, setIsAddressStyled] = useState(false);
  const [isCityStyled, setIsCityStyled] = useState(false);
  const [isDistrictStyled, setIsDistrictStyled] = useState(false);
  
  const [isPinStyled, setIsPinStyled] = useState(false);
  const [senttoCreditStatus, setSenttoCreditStatus] = useState(false);
  const [enableCamDetailsStatus, setEnableCamDetailsStatus] = useState(false);
  const [vivritiChecklistStatus, setVivritiChecklistStatus] = useState(false);
  const [allDealers, setAllDealers] = useState([]);
  const selectRefDO = useRef(null);
  const selectRefSL = useRef(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [iframeUrl, setIframeUrl] = useState('');
  const [aadharDigiVerifiedByName, setAadharDigiVerifiedByName] = useState("");
  const [aadharDigiVerifiedDate, setAadharDigiVerifiedDate] = useState("");
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [csvData, setCsvData] = useState([]);
  const [bulkApiResponseArr, setBulkApiResponseArr] = useState([]);
  
  const [formValues, setFormValues] = useState({
    chassis_number: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

const handleFileUpload = (event) => {
  const file = event.target.files[0];
  if (!file) return;

  Papa.parse(file, {
    header: true,
    skipEmptyLines: true,
    complete(results) {
      const chassisArray = results.data
        .map(row => row.chassis_number?.trim()) // Adjust this key if needed
        .filter(Boolean); // Remove undefined/null/empty values

      setCsvData(chassisArray);
      console.log('Chassis Numbers:', chassisArray);
    },
  });
};

  const handleSendToAPI = async () => {
     handleChassisNumberDetails('multiple');
  };

  const handleChassisNumberDetails = (actionName='single') => {
    let chassisNumbers = [];
    if(actionName === 'multiple'){
       setPreloaderBulkChassisNumber(true);
       chassisNumbers = csvData;
    }else{
       setPreloaderStatusChassisNumber(true);
       chassisNumbers = [formValues.chassis_number];
    } 
   
    const params = { chassis_numbers: chassisNumbers, "brief" : 'check_chassis_number', 'actionName' : actionName };
    const requestData = encryptData(params);
    const response = actions.validateToolsDetails(requestData);

    response
      .then((result) => {
        // console.log("Promise resolved - add/edit lead form:", result);
        setLeadPanDetails(""); 
         setBulkApiResponseArr([]);
        if (result.data.success === 1) {
           
          if(actionName === 'multiple'){
            setPreloaderBulkChassisNumber(false);
          }else{
            setPreloaderStatusChassisNumber(false);
          }
          toast.success(result.data.message, {
            position: "top-right",
          });

          const BefiscHtml = "";
          const BefiscStatus = "";

          if (
            Object.prototype.hasOwnProperty.call(
              result.data.data,
              "befiscApiRunStatus"
            ) &&
            result.data.data.befiscApiRunStatus
          ) {
            if (
              Object.prototype.hasOwnProperty.call(
                result.data.data,
                "bulkApiResponse"
              )
            ) {
              const apiResponseObj = result.data.data.bulkApiResponse; 
               console.log("2222 Befisc apiResponseObj= ", apiResponseObj);
              setBulkApiResponseArr(apiResponseObj);
            }

           
          }  

          setOutputBefiscHtml(BefiscHtml);
          setChassisNumberDetailsInfoName(BefiscStatus);
        } else {
          if(actionName === 'multiple'){
            setPreloaderBulkChassisNumber(false);
          }else{
            setPreloaderStatusChassisNumber(false);
          }
          toast.error(result.data.message, {
            position: "top-right",
          });
        }
      })
      .catch((error) => {
        if(actionName === 'multiple'){
            setPreloaderBulkChassisNumber(false);
          }else{
            setPreloaderStatusChassisNumber(false);
          }
        // console.error("Promise rejected - add/edit lead form:", error);
        toast.error(error, {
          position: "top-right",
        });
      });
  };

    

  if (!userHasPermission) {
    // Redirect or render an access denied message
    return <AccessDenied />;
  }

  return (
    <>
      <Helmet>
        <title> {leadId === "" ? "Chassis Number Information" : "Chassis Number Information"} Lead | Ckers </title>
      </Helmet>
      <Container>
        <div className="row align-items-center"> 
          <div className="col-md-12">
            <Typography variant="h4" sx={{ mb: 5 }}>
              {leadId === "" ? (
                "Check Chassis Number Information"
              ) : (
                <>
                  {pageHeading}
                  <br />
                  <Typography variant="body3" sx={{ color: "red" }}>
                    {isExternalUserContent}
                  </Typography>
                </>
              )}
            </Typography>
          </div> 
        </div>
        <div id="main-wrap" className="mb-5">
              <div className="tab-content" id="pills-tabContent">
              <form>
            <div className="row">
              <div className="col-md-5">
                <div className="form-group">
                  <label htmlFor="chassis_number">
                    <span>
                      Chassis Number{" "}
                      <a style={{ color: "red" }}>* </a>
                    </span>
                    <input
                      type="tel"
                      id="chassis_number"
                      name="chassis_number"
                      className="form-control "
                      {...register("chassis_number")}
                      value={formValues.chassis_number}
                      onChange={handleChange}
                      readOnly={
                        userRoleType === "Credit" ||
                        leadStatusFlag === true ||
                        mobileReadOnly === true
                      }
                    /> 
                            <button
                              type="button"
                              className="btn btn-success float-right validate-phone"
                              onClick={() =>
                                handleChassisNumberDetails('single')
                              }
                            >
                              {preloaderStatusChassisNumber && (
                                <>
                                  <div
                                    className="spinner-border small-preloader"
                                    role="status"
                                  >
                                    <span className="visually-hidden">
                                      {" "}
                                      Loading...
                                    </span>
                                  </div>
                                </>
                              )}
                             Submit
                            </button>
                  </label>
                  {errors.chassis_number && (
                    <span className="required">
                      {" "}
                      This field is required.
                    </span>
                  )}
                </div> 
              </div>
               <div className="col-md-2">&nbsp;</div>    
               <div className="col-md-5" style={{ borderRight: "1px solid #aaa" }}>
                <div className="form-group">
                  <label htmlFor="chassis_number">
                    <span>
                      Import CSV with Multiple Chassis Numbers{" "}
                      <a style={{ color: "red" }}>* </a>
                    </span>
                          <input type="file" accept=".csv" onChange={handleFileUpload} />
                          <button type="button"
                          className="btn btn-success" 
                          onClick={handleSendToAPI} disabled={csvData.length === 0}
                          >
                            {preloaderBulkChassisNumber && (
                                <>
                                  <div
                                    className="spinner-border small-preloader"
                                    role="status"
                                  >
                                    <span className="visually-hidden">
                                      {" "}
                                      Loading...
                                    </span>
                                  </div>
                                </>
                              )} Send to API
                          </button>
                  </label>
                </div>
              </div>
            </div>
          </form> 

           <div className="table-wrap table-responsive">
            <table className="table table-hover" id="exportBeatPlanExcelFile">
                <thead>
                    <tr>
                        <th className="text-nowrap">Chassis NO</th>
                        <th className="text-nowrap-">Result</th> 
                    </tr>
                </thead>

                <tbody>
                    {bulkApiResponseArr.map((item, index) => (
                        <tr key={index}>
                            <td>{item?.chassis_number}</td>
                            <td> 
                               <div className="row">
                               <div className="col-md-6">
                              <ul>
                              <li><strong>Chassis Number : </strong> {item?.result?.chassis_number}</li>
                              <li><strong>Registration Number : </strong> {item?.result?.registration_number}</li>
                              <li><strong>Owner Name : </strong> {item?.result?.user_name}</li>
                              <li><strong>Vehicle Make/Model : </strong> {item?.result?.vehicle_make_model}</li>
                              <li><strong>Fuel Type : </strong> {item?.result?.vehicle_fuel_description}</li>
                              <li><strong>Fitness Upto : </strong> {item?.result?.fit_upto}</li>
                              <li><strong>Registration Date : </strong> {item?.result?.registration_date}</li>
                              <li><strong>Vehicle Age : </strong> {item?.result?.vehicle_age}</li>
                              <li><strong>Insurance Policy No : </strong> {item?.result?.insurance?.policyNumber}</li>
                              <li><strong>Insurance Company : </strong> {item?.result?.insurance?.company}</li>
                              <li><strong>Insurance Valid Till : </strong> {item?.result?.insurance?.validTill}</li>
                              <li><strong>Owner Address : </strong> {item?.result?.user_present_address}</li>
                            </ul>
                            </div>
                            <div className="col-md-6">
                            <ul>
                              <li><strong>Father Name : </strong> {item?.result?.father_name}</li>
                              <li><strong>Financer : </strong> {item?.result?.financer}</li>
                              <li><strong>Vehicle category : </strong> {item?.result?.vehicle_category}</li>
                              <li><strong>Vehicle class description : </strong> {item?.result?.vehicle_class_description}</li>
                              <li><strong>Vehicle cubic capacity : </strong> {item?.result?.vehicle_cubic_capacity}</li>
                              <li><strong>Vehicle gross weight : </strong> {item?.result?.vehicle_gross_weight}</li>
                              <li><strong>Vehicle maker description : </strong> {item?.result?.vehicle_maker_description}</li>
                              <li><strong>Vehicle manufactured date : </strong> {item?.result?.vehicle_manufactured_date}</li>
                              <li><strong>Vehicle number of cylinders : </strong> {item?.result?.vehicle_number_of_cylinders}</li>
                              <li><strong>Vehicle seating capacity : </strong> {item?.result?.insurance?.vehicle_seating_capacity}</li>
                              <li><strong>Month year remaining for insurance exp : </strong> {item?.result?.insurance?.month_year_remaining_for_insurance_exp}</li>
                              <li><strong>City : </strong> {item?.result?.insurance?.city}</li>
                              <li><strong>State : </strong> {item?.result?.state}</li>
                            </ul>
                            </div>
                            </div>
                            
                            </td>
                        </tr>
                    ))}

                    {bulkApiResponseArr.length < 1 && (
                        <>
                            <tr>
                                <td colSpan={2} className='text-center py-3 fw-bold'>No record found</td>
                            </tr>
                        </>
                    )}
                </tbody>
            </table>
        </div>
         
        </div>
        </div>
      </Container> 
    </>
  );
};
function mapStateToProps(state) {
  return {
    leadsData: state.leadsData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      Object.assign(
        leadActions.default
      ),
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RCfromChassis);